<template>
    <div class="flex flex-col items-start gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex flex-col items-start gap-3 sm:flex-row sm:items-center">
            <button
                type="button"
                data-testid="wrong-person-button"
                class="body-small text-valence-grey-750 hover:underline flex items-center gap-1.5 text-left"
                @click="emit('wrong-person')">
                <i class="bi bi-question-circle text-xs/none" aria-hidden="true"></i>
                Wrong person?
            </button>
            <button v-if="showDirectorySearch" type="button" class="body-small text-valence-grey-750 hover:underline text-left" @click="emit('directory-search')">
                Already in my people
            </button>
        </div>
        <button type="button" class="body-small text-valence-grey-750 hover:underline flex items-center gap-1.5 text-left sm:text-right" @click="emit('decline')">
            <i class="bi bi-x text-lg/none" aria-hidden="true"></i>
            Not a person
        </button>
    </div>
</template>

<script setup lang="ts">
type Props = {
    showDirectorySearch?: boolean;
};

const { showDirectorySearch = false } = defineProps<Props>();

const emit = defineEmits<{
    "wrong-person": [];
    "directory-search": [];
    decline: [];
}>();
</script>
